/** 长邮箱中间省略，保证一行内显示（如 hdjdk....@gmail.com） */
export function formatEmailForDisplay(email: string): string {
  const normalized = email.trim().toLowerCase();
  if (!normalized) {
    return "";
  }
  const atIdx = normalized.indexOf("@");
  if (atIdx <= 0) {
    return normalized;
  }
  const local = normalized.slice(0, atIdx);
  const domain = normalized.slice(atIdx + 1);
  const maxLocalLen = 10;
  const ellipsis = "....";
  if (local.length <= maxLocalLen && normalized.length <= 24) {
    return normalized;
  }
  const head = local.slice(0, maxLocalLen) + ellipsis;
  return domain ? `${head}@${domain}` : head;
}
